import { render } from "./About.vue?vue&type=template&id=468eefce&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=468eefce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-468eefce"

export default script